// Espelho do backend (backend/src/helpers/ContactTicketMode.ts), que decide de
// verdade. Setting `unifyTicketsByContact` = "disabled" é o modo "um por
// conexão" para contato 1:1: cada conexão tem o seu chamado com o contato, o
// envio sem conexão escolhida sai pela conexão do atendente e o chamado de
// outra conexão nunca é assumido nem reaproveitado. Grupo segue `groupTicketUnify`.
import { getManagedWhatsappIds } from "./canAccessTicket";

export const isPerConnectionContactTickets = (getSetting) =>
  typeof getSetting === "function" && getSetting("unifyTicketsByContact") === "disabled";

// A regra vale para contato 1:1 com telefone. Contato de Instagram (sem número)
// e de email (número = endereço) seguem o fluxo antigo.
export const isPerConnectionContact = (contact) =>
  !!contact && !contact.isGroup && !!contact.number && !String(contact.number).includes("@");

// Conexões que contam como "do atendente": a padrão ∪ as atribuídas. Sessão
// antiga sem `user.whatsapps` fica só com a padrão.
export const ownConnectionIds = (user) => {
  const managed = getManagedWhatsappIds(user);
  if (managed !== null) return managed;
  return user?.whatsappId ? [Number(user.whatsappId)] : [];
};

// Chamados que o atendente pode reaproveitar no modo "um por conexão": só os das
// conexões dele (grupo, Instagram e email ficam de fora da regra).
export const ticketsOnOwnConnections = (tickets, user) => {
  const ids = ownConnectionIds(user);
  return (Array.isArray(tickets) ? tickets : []).filter(
    (t) =>
      t?.isGroup ||
      (t?.contact && !isPerConnectionContact(t.contact)) ||
      ids.includes(Number(t?.whatsappId))
  );
};
